import { Add, CloudDownload, CloudSync, Delete, Restore, Save } from '@mui/icons-material';
import { Box } from '@mui/material';
import React from 'react';
import { StyledButton } from '../../../components/styles/StyledButtons';

interface FAQAdminToolbarProps {
  onAddGroup: () => void;
  onSave: () => void;
  onReloadFromBucket: () => void;
  onRevertToPublished: () => void;
  onDownload: () => void;
  onClearBucket: () => void;
}

const FAQAdminToolbar: React.FC<FAQAdminToolbarProps> = ({
  onAddGroup,
  onSave,
  onReloadFromBucket,
  onRevertToPublished,
  onDownload,
  onClearBucket,
}) => (
  <Box
    sx={{
      display: 'flex',
      gap: 1,
      alignItems: 'center',
      mb: 2,
      flexWrap: 'wrap',
    }}
  >
    <StyledButton variant="contained" startIcon={<Add />} onClick={onAddGroup}>
      Add Group
    </StyledButton>
    <StyledButton variant="contained" color="primary" startIcon={<Save />} onClick={onSave}>
      Save FAQs
    </StyledButton>
    <StyledButton variant="outlined" startIcon={<CloudSync />} onClick={onReloadFromBucket}>
      Revert to last saved
    </StyledButton>
    <StyledButton variant="outlined" startIcon={<Restore />} onClick={onRevertToPublished}>
      Revert to last published
    </StyledButton>
    <StyledButton variant="outlined" startIcon={<CloudDownload />} onClick={onDownload}>
      Download Bucket JSON
    </StyledButton>
    <StyledButton buttonVariant="warning" startIcon={<Delete />} onClick={onClearBucket}>
      Clear Bucket
    </StyledButton>
  </Box>
);

export default FAQAdminToolbar;
